var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _abortController, _abortController2, _ProductModel_instances, waitForModelViewerUI_fn;
import { Component } from "@theme/component";
import { ThemeEvents, MediaStartedPlayingEvent } from "@theme/events";
import { DialogCloseEvent } from "@theme/dialog";
class DeferredMedia extends Component {
  constructor() {
    super(...arguments);
    /** @type {boolean} */
    __publicField(this, "isPlaying", false);
    __privateAdd(this, _abortController, new AbortController());
    /**
     * Shows the deferred media content
     */
    __publicField(this, "showDeferredMedia", () => {
      this.loadContent(true);
      this.isPlaying = true;
      this.updatePlayPauseHint(this.isPlaying);
    });
  }
  connectedCallback() {
    super.connectedCallback();
    const signal = __privateGet(this, _abortController).signal;
    document.addEventListener(ThemeEvents.mediaStartedPlaying, this.pauseMedia.bind(this), { signal });
    window.addEventListener(DialogCloseEvent.eventName, this.pauseMedia.bind(this), { signal });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    __privateGet(this, _abortController).abort();
  }
  /**
   * Updates the visual hint for play/pause state
   * @param {boolean} isPlaying - Whether the video is currently playing
   */
  updatePlayPauseHint(isPlaying) {
    const toggleMediaButton = this.refs.toggleMediaButton;
    if (toggleMediaButton instanceof HTMLElement) {
      toggleMediaButton.classList.remove("hidden");
      const playIcon = toggleMediaButton.querySelector(".icon-play");
      if (playIcon) playIcon.classList.toggle("hidden", isPlaying);
      const pauseIcon = toggleMediaButton.querySelector(".icon-pause");
      if (pauseIcon) pauseIcon.classList.toggle("hidden", !isPlaying);
    }
  }
  /**
   * Loads the content
   * @param {boolean} [focus] - Whether to focus the content
   */
  loadContent(focus = true) {
    if (this.getAttribute("data-media-loaded")) return;
    this.dispatchEvent(new MediaStartedPlayingEvent(this));
    const content = this.querySelector("template")?.content.firstElementChild?.cloneNode(true);
    if (!content) return;
    this.setAttribute("data-media-loaded", "true");
    this.appendChild(content);
    if (focus && content instanceof HTMLElement) {
      content.focus();
    }
    this.refs.deferredMediaPlayButton?.classList.add("deferred-media__playing");
    if (content instanceof HTMLVideoElement && content.getAttribute("autoplay")) {
      content.play();
    }
  }
  /**
   * Toggle play/pause state of the media
   */
  toggleMedia() {
    if (this.isPlaying) {
      this.pauseMedia();
    } else {
      this.playMedia();
    }
  }
  playMedia() {
    const iframe = this.querySelector("iframe[data-video-type]");
    if (iframe) {
      iframe.contentWindow?.postMessage(
        iframe.dataset.videoType === "youtube" ? '{"event":"command","func":"playVideo","args":""}' : '{"method":"play"}',
        "*"
      );
    } else {
      this.querySelector("video")?.play();
    }
    this.isPlaying = true;
    this.updatePlayPauseHint(this.isPlaying);
  }
  /**
   * Pauses the media
   */
  pauseMedia() {
    const iframe = this.querySelector("iframe[data-video-type]");
    if (iframe) {
      iframe.contentWindow?.postMessage(
        iframe.dataset.videoType === "youtube" ? '{"event":"command","func":"pauseVideo","args":""}' : '{"method":"pause"}',
        "*"
      );
    } else {
      this.querySelector("video")?.pause();
    }
    this.isPlaying = false;
    if (this.getAttribute("data-media-loaded")) {
      this.updatePlayPauseHint(this.isPlaying);
    }
  }
}
_abortController = new WeakMap();
if (!customElements.get("deferred-media")) {
  customElements.define("deferred-media", DeferredMedia);
}
class ProductModel extends DeferredMedia {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ProductModel_instances);
    __privateAdd(this, _abortController2, new AbortController());
  }
  loadContent() {
    super.loadContent();
    Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this)
      }
    ]);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    __privateGet(this, _abortController2).abort();
  }
  pauseMedia() {
    super.pauseMedia();
    this.modelViewerUI?.pause();
  }
  playMedia() {
    super.playMedia();
    this.modelViewerUI?.play();
  }
  /**
   * @param {Error[]} errors
   */
  async setupModelViewerUI(errors) {
    if (errors) return;
    if (!Shopify.ModelViewerUI) {
      await __privateMethod(this, _ProductModel_instances, waitForModelViewerUI_fn).call(this);
    }
    if (!Shopify.ModelViewerUI) return;
    const element = this.querySelector("model-viewer");
    if (!element) return;
    const signal = __privateGet(this, _abortController2).signal;
    this.modelViewerUI = new Shopify.ModelViewerUI(element);
    if (!this.modelViewerUI) return;
    this.playMedia();
    let pointerStartX = 0;
    let pointerStartY = 0;
    element.addEventListener(
      "pointerdown",
      (event) => {
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
      },
      { signal }
    );
    element.addEventListener(
      "click",
      (event) => {
        const distanceX = Math.abs(event.clientX - pointerStartX);
        const distanceY = Math.abs(event.clientY - pointerStartY);
        const totalDistance = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
        if (totalDistance < 10) {
          this.pauseMedia();
        }
      },
      { signal }
    );
  }
}
_abortController2 = new WeakMap();
_ProductModel_instances = new WeakSet();
waitForModelViewerUI_fn = async function() {
  const maxAttempts = 10;
  const interval = 50;
  for (let i = 0; i < maxAttempts; i++) {
    if (Shopify.ModelViewerUI) {
      return;
    }
    await new Promise((resolve) => setTimeout(resolve, interval));
  }
};
if (!customElements.get("product-model")) {
  customElements.define("product-model", ProductModel);
}
